import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from '@app/utils/dayjs-setup';

import el from './locales/el.json';
import en from './locales/en.json';
import {
  DEFAULT_APP_LANGUAGE,
  SUPPORTED_LANGUAGE_DETAILS,
  SUPPORTED_LANGUAGES,
  type AppLanguage,
} from './supportedLanguages';

// Registered before init and before any component subscribes, so dayjs and <html lang> are
// switched before React re-renders (lang lets CSS uppercase drop the Greek tonos).
export const applyLanguageSideEffects = (language?: string) => {
  const base = (language ?? '').toLowerCase().split(/[-_]/)[0];
  const lang: AppLanguage = base in SUPPORTED_LANGUAGE_DETAILS ? (base as AppLanguage) : DEFAULT_APP_LANGUAGE;
  dayjs.locale(SUPPORTED_LANGUAGE_DETAILS[lang].dayjsLocale);
  if (typeof document !== 'undefined') document.documentElement.lang = lang;
};
i18n.on('languageChanged', applyLanguageSideEffects);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      el: { translation: el },
    },

    fallbackLng: DEFAULT_APP_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false,
    },

    returnNull: false,
    returnEmptyString: false,

    react: {
      useSuspense: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_language',
    },
  });

export default i18n;
